import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = ["href"]
const _hoisted_3 = { "format-key": "1" }
const _hoisted_4 = {
  key: 1,
  class: "_mt-2 _flex _gap-1"
}
const _hoisted_5 = { class: "_flexcol" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_heading = _resolveComponent("base-heading")
  const _component_localize = _resolveComponent("localize")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($options.cardClasses),
    "data-qa": `timeline-card:${$props.type}`
  }, [
    _createElementVNode("div", {
      class: _normalizeClass($options.badgeModel.classes),
      "data-qa": "timeline-card-elements:Badge"
    }, [
      _createVNode(_component_base_icon, {
        name: $options.badgeModel.icon,
        class: "_mr-1"
      }, null, 8 /* PROPS */, ["name"]),
      _createTextVNode(" " + _toDisplayString($options.badgeModel.text), 1 /* TEXT */)
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass($options.cardContentClasses),
      "data-qa": "timeline-card-content"
    }, [
      _createVNode(_component_base_heading, {
        tag: "h4",
        class: "gfu-hd gfu-hd--h4"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.status), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      ($props.copy)
        ? (_openBlock(), _createBlock(_component_localize, {
            key: 0,
            resource: $props.copy,
            class: "_mb-a",
            "data-qa": "timeline-card-elements:Copy"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                "format-key": "0",
                class: "gfu-link gfu-link--accent",
                href: $props.learnMoreUrl,
                target: "_blank",
                rel: "noopener noreferrer"
              }, _toDisplayString($options.learnMoreLabel), 9 /* TEXT, PROPS */, _hoisted_2),
              _createElementVNode("strong", _hoisted_3, _toDisplayString($options.backerNumber), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"]))
        : _createCommentVNode("v-if", true),
      ($options.isActionVisible || $options.isAdditionalInfoVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            ($options.isAdditionalInfoIconVisible)
              ? (_openBlock(), _createBlock(_component_base_icon, {
                  key: 0,
                  name: $options.additionalInfoIconName
                }, null, 8 /* PROPS */, ["name"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_5, [
              ($options.isAdditionalInfoVisible)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent($options.additionalInfoComponent.component), _mergeProps({ key: 0 }, $options.additionalInfoComponent.props, {
                    class: $options.additionalInfoComponent.classes,
                    "data-qa": "timeline-card-elements:AdditionalInfo"
                  }), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.additionalInfoComponent.text) + " ", 1 /* TEXT */),
                      ($props.tooltipText)
                        ? (_openBlock(), _createBlock(_component_tooltip, {
                            key: 0,
                            "icon-name": "circle-info",
                            text: $props.tooltipText
                          }, null, 8 /* PROPS */, ["text"]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                  }, 16 /* FULL_PROPS */, ["class"]))
                : _createCommentVNode("v-if", true),
              ($options.isActionVisible)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent($options.action.component), _mergeProps({ key: 1 }, $options.action.props, {
                    class: "_tc--accent _ttl _pa-0 gfu-link",
                    onClick: $options.sendAnalyticsEvent,
                    "data-qa": "timeline-card-elements:Action"
                  }), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.action.text), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 16 /* FULL_PROPS */, ["onClick"]))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}